import React, { useEffect, useMemo, useState } from 'react';
import { Typography, Row, Col, Card, RadioChangeEvent } from 'antd';
import { useLocation } from 'react-router-dom';
// import styled from 'styled-components';

import { SearchBar } from './SearchBar';
import { AutoCompleteResultForEntity, EntityType } from '../../types.generated';
import EntityRegistry from '../entity/EntityRegistry';
import { HeaderLinks, IngestionTabType } from '../shared/admin/HeaderLinks';
import { breadCrumbUtilService } from './utils/breadcrumbsUtilService';
import { AppBreadcrumb } from './AppBreadcrumbs';
import { BreadcrumbContextType, useBreadcrumbContext } from './context/BreadcrumbContext';
// import { useAppConfig } from '../useAppConfig';
// import { ViewSelect } from '../entity/view/select/ViewSelect';

const styles = {
    pageHeader: { marginBottom: 0 },
    pageHeaderRow: { marginBottom: '24px' },
};

// const ViewSelectContainer = styled.span`
//     margin-right: 14px;
// `;

type Props = {
    initialQuery?: string;
    title?: string;
    placeholderText?: string;
    suggestions?: Array<AutoCompleteResultForEntity>;
    onSearch?: (query: string, type?: EntityType) => void;
    onQueryChange?: (query: string) => void;
    entityRegistry?: EntityRegistry;
    subtext?: string;
    areLinksHidden?: boolean;
    ingestionTabType?: IngestionTabType;
    handleIngestionModeChange?: (e: RadioChangeEvent) => void;
};

/**
 * A header containing a Logo, Search Bar view, & an account management dropdown.
 */
export const SearchHeader = ({
    initialQuery = '',
    title = '',
    placeholderText = '',
    suggestions = [],
    onSearch = () => {},
    onQueryChange = () => {},
    entityRegistry,
    subtext = '',
    areLinksHidden,
    ingestionTabType,
    handleIngestionModeChange,
}: Props) => {
    // const appConfig = useAppConfig();
    // const viewsEnabled = appConfig.config?.viewsConfig?.enabled;

    const location = useLocation();

    // Get breadcrumbs based on current route
    const { routeMappings } = useMemo(() => breadCrumbUtilService(), []);
    const { breadcrumbArray, setBreadcrumbArray }: BreadcrumbContextType = useBreadcrumbContext();

    const [breadcrumbs, setBreadcrumbs] = useState(routeMappings[location.pathname]);

    useEffect(() => {
        setBreadcrumbs(routeMappings[location.pathname]);
    }, [location.pathname, routeMappings]);

    useEffect(() => {
        setBreadcrumbArray(Array.isArray(breadcrumbs) ? breadcrumbs : []);
    }, [breadcrumbs, setBreadcrumbArray]);

    // Find matching route mapping for current path
    if (!breadcrumbs) {
        // Check if pathname starts with any of the route patterns
        const matchingPattern = Object.keys(routeMappings).find((pattern: string) =>
            location.pathname.startsWith(`${pattern.replace('*', '')}/`),
        );
        if (matchingPattern) {
            setBreadcrumbs(routeMappings[matchingPattern]);
        }
    }

    return (
        <>
            <Row justify="space-between" align="middle" style={styles.pageHeaderRow} className="f-justify-center-xs">
                <Col>
                    <Row
                        align="middle"
                        justify="space-between"
                        style={styles.pageHeader}
                        className="f-justify-center-xs"
                    >
                        <Col flex="auto">
                            <AppBreadcrumb breadcrumbs={breadcrumbArray} />
                            <Typography.Text className="page-heading f-text-capitalize" style={styles.pageHeader}>
                                {title || (breadcrumbArray[breadcrumbArray.length - 1]?.name ?? '')}
                            </Typography.Text>
                        </Col>
                    </Row>
                    {subtext && (
                        <Row>
                            <Col>
                                <Typography.Paragraph type="secondary">{subtext}</Typography.Paragraph>
                            </Col>
                        </Row>
                    )}
                </Col>
                <Col>
                    {/* {viewsEnabled && (
                        <ViewSelectContainer>
                            <ViewSelect />
                        </ViewSelectContainer>
                    )} */}
                    <HeaderLinks
                        areLinksHidden={areLinksHidden}
                        ingestionTabType={ingestionTabType}
                        handleIngestionModeChange={handleIngestionModeChange}
                    />
                </Col>
            </Row>
            {entityRegistry && (
                <Card className="pa-3">
                    <SearchBar
                        combineSiblings
                        showQuickFilters
                        onSearch={onSearch}
                        suggestions={suggestions}
                        initialQuery={initialQuery}
                        onQueryChange={onQueryChange}
                        entityRegistry={entityRegistry}
                        //  viewsEnabled={viewsEnabled}
                        placeholderText={placeholderText}
                        // setIsSearchBarFocused={setIsSearchBarFocused}
                    />
                </Card>
            )}
        </>
    );
};
